const IS_HTTPS = window.location.protocol === 'https:';
const AUCTIONEER_DATA_TEMPLATE_SAMPLE_FILE = 'sampleAuctioneerMatrixUploadFile.xlsx';
const BEARER_PREFIX = 'Bearer';
const STORAGE_ACCESS_TOKEN_KEY = 'access.token';
const STORAGE_FAVICON_KEY = 'favicon';
const STORAGE_LOGO_KEY = 'logo';
const BEARER_REGEX = new RegExp(`${BEARER_PREFIX}\\s([A-Za-z0-9-_=]+\\.[A-Za-z0-9-_=]+\\.[A-Za-z0-9-_.+/=]+)`, 'i');
const X_REQUESTED_WITH_HEADER = 'XMLHttpRequest';
const TIME_TO_IDLE_IN_MINS = 30;
const WS_INACTIVITY_TIMEOUT_IN_SECS = 30;
const IDLE_POPUP_OFFSET_IN_MINS = 1;
const PREAUTH_LOGIN_PATH = '/pre-login';
const AUTH_LOGIN_PATH = '/login';
const AUTH_LOGOUT_PATH = '/logout';
const AUTH_SSO_PATH = '/sso';
const AUTH_REFRESH_TOKEN_PATH = '/refresh-token';
const PUBLIC_CONFIG_PATH = '/public';
const PRIVATE_CONFIG_PATH = '/private';
const CLIENT_LOGGER_PATH = '/client-logger';
const MIN_PRICE_STEP = 0.01;
const AUCTION_LIMIT_STEP = 1;
const SORT_ASC = 'ASC';
const SORT_DESC = 'DESC';
const DEFAULT_EXCHANGE_RATE = '1.0000';
const DEFAULT_EXVHANGE_RATE_STEP = 0.0001;
const DEFAULT_QUANTITY_STEP = 1;
const DEFAULT_PRICE_STEP = 0.01;
const DEFAULT_LIMIT_VALUE_STEP = 0.01;
const MIN_AUCTIONEER_DATA_QUANTITY = 0;
const GRAPHQL_PATH = '/graphql';
const GRAPHQL_WS_PATH = '/graphqlws';
const AUTH_PATH = '/auth';
const CONFIG_PATH = '/config';
const ENV_PATH = '/env';
const LOST_PASSWORD_PATH = '/request-token-for-password-reset';
const RESET_PASSWORD_PATH = '/reset-password';
const RESET_LINK_VALIDITY = '/check-reset-link-validity';
const LOST_2FA_TOKEN_PATH = '/request-token-for-2fa-reset';
const GENERATE_2FA_QRIMAGE_PATH = '/generate-2fa-qrimage';
const RESET_2FA_TOKEN_PATH = '/reset-2fa';
const DOWNLOAD_PATH = '/download';
const DOWNLOAD_REPORT_PATH = '/report';
const VALIDATION_URL = '/validate';
const DOWNLOAD_AUCTIONEER_DATA_TEMPLATE_PATH = '/auctioneer-data-template';
const DOWNLOAD_CASH_LIMIT_CONFIRMATION_FILE_PATH = '/cash-limit-confirmation-file';
const DOWNLOAD_SAMPLE_FILE = '/sample';
const SINGLE_EMAIL_REGEX = '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?';
const EMAIL_REGEX = new RegExp(`^(${SINGLE_EMAIL_REGEX})?$`);
const EMAILS_REGEX = new RegExp(`^((${SINGLE_EMAIL_REGEX};\\s?)*(${SINGLE_EMAIL_REGEX}))?$`);
const COMMA_SEPARATED_EMAILS_REGEX = new RegExp(`^((${SINGLE_EMAIL_REGEX},\\s?)*(${SINGLE_EMAIL_REGEX}))?$`);
const DISPLAY_FIELD_ERROR_DELAY_IN_MS = 500;
const MIN_SPOT_REFERENCE_PRICE = 0.01;
const MAX_SPOT_REFERENCE_PRICE = 100000;
const MIN_ABSOLUTE_DEVIATION = 0;
const MAX_ABSOLUTE_DEVIATION = 100000;
const MIN_RELATIVE_DEVIATION = 0;
const MAX_RELATIVE_DEVIATION = 100;
const MIN_REVENUE_SPLIT = 0;
const MAX_REVENUE_SPLIT = 100;
const MIN_SMALLEST_UNIT = 1;
const MIN_MAXIMUM_BID_SIZE = 1;
const DAY_IN_SECONDS = 86400;
const PASSWORD_EXPIRATION_WARNING_DAYS = 14;
const PASSWORD_EXPIRATION_ERROR_DAYS = 7;
const PASSWORD_EXPIRATION_DEFAULT_DAYS = 89; // actually it's a "little bit less" than 90 days in seconds, which is 89 after "Math.floor()" is applied
const DYNAMIC_WIDTH_GAP_IN_PX = 15;
const CORRELATIONS_CLEANUP_IN_MINS = 5;
const UPLOAD_PATH = '/upload';
const UPLOAD_EXCHANGE_RATES_PATH = '/exchange-rates';
const UPLOAD_AUCTIONEER_DATA_TEMPLATE_PATH = '/auctioneer-data-template';
const UPLOAD_CASH_LIMITS_PATH = '/cash-limits';
const UPLOAD_BIDS_PATH = '/bids';
const UPLOAD_MEMBERS_PATH = '/members';
const UPLOAD_USERS_PATH = '/users';
const ENERGY_PER_LOT_PROPERTY_DEBOUNCE_IN_MS = 300;
const VALIDITY_DELAY_IN_MS = 300;
const MIN_RATE_LIMIT_VALUE = 1;
const MAX_RATE_LIMIT_VALUE = 99999;
const RATE_LIMIT_VALUE_STEP = 1;
const ALL_USERS_OPTION_VALUE = 'ALL_USERS';
const MAX_RETRIES_WHEN_NETWORK_ERROR = 3;
const HOURS_DIFF_TO_WARN = 2;
const REDIRECT_URI = new URL('/sso', window.location.origin);

export default {
    IS_HTTPS,
    AUCTIONEER_DATA_TEMPLATE_SAMPLE_FILE,
    STORAGE_ACCESS_TOKEN_KEY,
    STORAGE_FAVICON_KEY,
    STORAGE_LOGO_KEY,
    BEARER_PREFIX,
    BEARER_REGEX,
    X_REQUESTED_WITH_HEADER,
    TIME_TO_IDLE_IN_MINS,
    WS_INACTIVITY_TIMEOUT_IN_SECS,
    IDLE_POPUP_OFFSET_IN_MINS,
    PREAUTH_LOGIN_PATH,
    AUTH_LOGIN_PATH,
    AUTH_LOGOUT_PATH,
    AUTH_SSO_PATH,
    AUTH_REFRESH_TOKEN_PATH,
    PUBLIC_CONFIG_PATH,
    PRIVATE_CONFIG_PATH,
    CLIENT_LOGGER_PATH,
    MIN_PRICE_STEP,
    AUCTION_LIMIT_STEP,
    SORT_ASC,
    SORT_DESC,
    DEFAULT_EXCHANGE_RATE,
    DEFAULT_EXVHANGE_RATE_STEP,
    DEFAULT_QUANTITY_STEP,
    DEFAULT_PRICE_STEP,
    DEFAULT_LIMIT_VALUE_STEP,
    MIN_AUCTIONEER_DATA_QUANTITY,
    GRAPHQL_PATH,
    GRAPHQL_WS_PATH,
    AUTH_PATH,
    CONFIG_PATH,
    ENV_PATH,
    LOST_PASSWORD_PATH,
    RESET_PASSWORD_PATH,
    RESET_LINK_VALIDITY,
    LOST_2FA_TOKEN_PATH,
    GENERATE_2FA_QRIMAGE_PATH,
    RESET_2FA_TOKEN_PATH,
    DOWNLOAD_PATH,
    DOWNLOAD_REPORT_PATH,
    WAF_VALIDATION_URL: VALIDATION_URL,
    DOWNLOAD_AUCTIONEER_DATA_TEMPLATE_PATH,
    DOWNLOAD_CASH_LIMIT_CONFIRMATION_FILE_PATH,
    DOWNLOAD_SAMPLE_FILE,
    EMAIL_REGEX,
    EMAILS_REGEX,
    COMMA_SEPARATED_EMAILS_REGEX,
    DISPLAY_FIELD_ERROR_DELAY_IN_MS,
    MIN_SPOT_REFERENCE_PRICE,
    MAX_SPOT_REFERENCE_PRICE,
    MIN_ABSOLUTE_DEVIATION,
    MAX_ABSOLUTE_DEVIATION,
    MIN_RELATIVE_DEVIATION,
    MAX_RELATIVE_DEVIATION,
    MIN_REVENUE_SPLIT,
    MAX_REVENUE_SPLIT,
    MIN_SMALLEST_UNIT,
    MIN_MAXIMUM_BID_SIZE,
    DAY_IN_SECONDS,
    PASSWORD_EXPIRATION_WARNING_DAYS,
    PASSWORD_EXPIRATION_ERROR_DAYS,
    PASSWORD_EXPIRATION_DEFAULT_DAYS,
    DYNAMIC_WIDTH_GAP_IN_PX,
    CORRELATIONS_CLEANUP_IN_MINS,
    UPLOAD_PATH,
    UPLOAD_EXCHANGE_RATES_PATH,
    UPLOAD_AUCTIONEER_DATA_TEMPLATE_PATH,
    UPLOAD_CASH_LIMITS_PATH,
    ENERGY_PER_LOT_PROPERTY_DEBOUNCE_IN_MS,
    VALIDITY_DELAY_IN_MS,
    MIN_RATE_LIMIT_VALUE,
    MAX_RATE_LIMIT_VALUE,
    RATE_LIMIT_VALUE_STEP,
    ALL_USERS_OPTION_VALUE,
    UPLOAD_BIDS_PATH,
    UPLOAD_MEMBERS_PATH,
    UPLOAD_USERS_PATH,
    MAX_RETRIES_WHEN_NETWORK_ERROR,
    REDIRECT_URI,
    HOURS_DIFF_TO_WARN,
};
